// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"685":"a1837a95","921":"4c8a7f81"}[chunkId] + ".chunk.css";
};